import { colors } from '@alixpartners/ui-components';
import { ActionItem } from 'BudgetTracker/SecondaryNav/SecondaryNav.styles';
import styled from 'styled-components';
import { grey400, white } from 'styles/colors';

export const CenteredContainer = styled.div`
	width: 80%;
	display: flex;
	justify-content: center;
	justify-items: center;
	margin-top: 5%;
	margin-left: auto;
	margin-right: auto;
`;

export const DashBoardDiv = styled.div`
	display: flex;
	justify-content: space-between;
	flex: 0.4;
	flex-direction: column;
`;

export const NavDiv = styled.div`
	box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
	padding: 20px;
	margin: 20px;
`;

export const SearchWrapper = styled(ActionItem)`
	display: flex;
	align-items: center;
	margin: 1%;
	> div:first-child {
		width: 300px;
	}
`;

export const ChartWrapper = styled.div`
	display: flex;
	flex: 0.4;
`;

export const StyledGrid = styled.div`
	display: grid;
	box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
	grid-template-columns: repeat(7, 1fr);
	width: 100%;
	border: 1.5px solid ${colors.grey200};
	font-size: 14px;
	font-family: Roboto;
`;
export const TextGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(7, 1fr);
	width: 100%;
	border: none;
	font-size: 14px;
	font-family: Roboto;
`;
export const GridItem = styled.div`
	border: 1.5px solid ${colors.grey200}; /* Border around each grid item */
	font-size: 14px;
	height: 35px;
	text-align: center;
	display: flex;
	font-weight: bold;
	justify-content: center; /* Center content horizontally */
	align-items: center;
	padding: 5px;
`;
export const TextItem = styled.div`
	border: none; /* Border around each grid item */
	font-size: 14px;
	text-align: center;
	display: flex;
	justify-content: center; /* Center content horizontally */
	align-items: center;
	padding: 5px;
`;

export const PieChartData = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	font-size: 14px;
	margin-left: auto;
	margin-right:auto;
	background-color:${colors.chartDarkTeal}
	color:${white};
	border:1px solid ${grey400};
	padding : 5px;
`;

export const WaterfallWrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 64%;
	margin: 0px 0px 0px 20px;
	padding: 20px 20px 10px 20px;
	box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
`;

export const PieWrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 38%;
	margin: 0px 20px 0px 10px;
	padding: 20px 20px 10px 20px;
	box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
`;

export const ChartTitle = styled.div`
	font-weight: bold;
	font-size: 16px;
	font-family: Roboto;
	display: flex;
	justify-content: space-between;
	align-items: center;
`;
